import axios from "axios";

// Relative baseURL — the browser resolves it against whatever host is
// serving the SPA. Preview → same-origin ingress routes /api/* to the
// FastAPI pod; production → linguasub.in ingress does the same. This also
// removes the need for CORS on cookie'd requests since they're same-origin.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

// Unified language list — any of these can be picked as source OR target.
export const ALL_LANGS = [
  { key: "hindi", name: "Hindi" },
  { key: "bhojpuri", name: "Bhojpuri" },
  { key: "magahi", name: "Magahi" },
  { key: "awadhi", name: "Awadhi" },
  { key: "urdu", name: "Urdu" },
  { key: "tamil", name: "Tamil" },
  { key: "telugu", name: "Telugu" },
  { key: "bengali", name: "Bengali" },
  { key: "malayalam", name: "Malayalam" },
  { key: "gujarati", name: "Gujarati" },
  { key: "punjabi", name: "Punjabi" },
  { key: "english", name: "English" },
  { key: "chinese", name: "Chinese" },
  { key: "french", name: "French" },
  { key: "german", name: "German" },
  { key: "russian", name: "Russian" },
  { key: "japanese", name: "Japanese" },
  { key: "marathi", name: "Marathi" },
  { key: "spanish", name: "Spanish" },
  { key: "korean", name: "Korean" },
  { key: "italian", name: "Italian" },
];

// Legacy aliases (still imported in a few places) — both now point at the full list.
export const SOURCE_LANGS = ALL_LANGS;
export const TARGET_LANGS = ALL_LANGS;
